import { FunctionComponent, PropsWithChildren } from 'react';

interface TextLabelProps extends PropsWithChildren {}

export const TextLabel: FunctionComponent<TextLabelProps> = ({ children }) => {
  return <div className="text-xs font-semibold uppercase text-primary-950 dark:text-primary-500">{children}</div>;
};
